export default "__VITE_ASSET__20af2cc3__"